import React, { useState } from 'react';
import "./Navbar.css";
import logoarmure from "./Armure Logo.png";
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [expanded, setExpanded] = useState(false);
  const [productOpen, setProductOpen] = useState(false);
  const [warrantyOpen, setWarrantyOpen] = useState(false);

  const handleToggle = () => setExpanded(!expanded);

  const handleLinkClick = () => {
    setExpanded(false);
    setProductOpen(false);
    setWarrantyOpen(false);
  };

  const location = useLocation();
  const path = location.pathname;

  /* ---------- active‑link coloring ------------------------------ */
  const linkStyle = {
    home:        { color: path === '/'            ? '#ffc107' : '' },
    ultra:       { color: path === '/ultra'       ? '#ffc107' : '', backgroundColor: path === '/ultra'       ? 'white' : '' },
    ultraplus:   { color: path === '/ultraplus'   ? '#ffc107' : '', backgroundColor: path === '/ultraplus'   ? 'white' : '' },
    ultimate:    { color: path === '/ultimate'   ? '#ffc107' : '', backgroundColor: path === '/ultimate'    ? 'white' : '' },
    platinum:    { color: path === '/platinum'    ? '#ffc107' : '', backgroundColor: path === '/platinum'    ? 'white' : '' },
    glossblack:  { color: path === '/glossblack'  ? '#ffc107' : '', backgroundColor: path === '/glossblack'  ? 'white' : '' },
    matte:       { color: path === '/matte'       ? '#ffc107' : '', backgroundColor: path === '/matte'       ? 'white' : '' },
    windowfilm:  { color: path === '/windowfilm'  ? '#ffc107' : '', backgroundColor: path === '/windowfilm'  ? 'white' : '' },
    installers:  { color: path === '/installers'  ? '#ffc107' : '' },
    // warrantyAdmin:  { color: path === '/admin'   ? '#ffc107' : '' },
    warrantySearch: { color: path === '/search'  ? '#ffc107' : '' },
  };

  const isProductPage   = ["/ultra","/ultraplus","/ultimate","/platinum","/glossblack","/matte","/windowfilm"].includes(path);
  const isWarrantyPage  = ["/admin","/search"].includes(path);

  return (
    <nav className={`navbar navbar-expand-lg ${expanded ? 'show' : ''}`}>
      <div className="container-fluid">
        {/* mobile burger */}
        <button className="navbar-toggler"
                type="button"
                aria-controls="navbarNavDropdown"
                aria-expanded={expanded}
                aria-label="Toggle navigation"
                onClick={handleToggle}>
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* logo */}
        <Link to='/' className="navbar-brand" onClick={handleLinkClick}>
          <img src={logoarmure} className="navbarlogo img-fluid" alt="nav-logo" />
        </Link>

        {/* links */}
        <div className={`collapse navbar-collapse ${expanded ? 'show' : ''}`} id="navbarNavDropdown">
          <ul className="navbar-nav">
            <li className="nav-item">
              <Link to="/" className="nav-link" style={linkStyle.home} onClick={handleLinkClick}>
                HOME
              </Link>
            </li>

            {/* PRODUCTS dropdown */}
            <li className={`nav-item dropdown ${productOpen ? 'show' : ''}`}>
              <Link className="nav-link dropdown-toggle tb"
                    to="#"
                    role="button"
                    style={isProductPage ? { color: '#ffc107' } : {}}
                    aria-expanded={productOpen}
                    onClick={e => { e.preventDefault(); setProductOpen(!productOpen); }}>
                PRODUCTS
              </Link>
              <ul className={`dropdown-menu bg-dark ${productOpen ? 'show' : ''}`}>
                <li><Link className="dropdown-item text-warning" to="/ultra"      style={linkStyle.ultra}      onClick={handleLinkClick}>ULTRA</Link></li>
                <li><Link className="dropdown-item text-warning" to="/ultraplus"  style={linkStyle.ultraplus}  onClick={handleLinkClick}>ULTRA PLUS</Link></li>
                <li><Link className="dropdown-item text-warning" to="/ultimate"  style={linkStyle.ultimate}   onClick={handleLinkClick}>ULTIMATE</Link></li>
                <li><Link className="dropdown-item text-warning" to="/platinum"   style={linkStyle.platinum}   onClick={handleLinkClick}>PLATINUM</Link></li>
                <li><Link className="dropdown-item text-warning" to="/glossblack" style={linkStyle.glossblack} onClick={handleLinkClick}>GLOSS BLACK</Link></li>
                <li><Link className="dropdown-item text-warning" to="/matte"      style={linkStyle.matte}      onClick={handleLinkClick}>MATTE</Link></li>
                <li><Link className="dropdown-item text-warning" to="/windowfilm" style={linkStyle.windowfilm} onClick={handleLinkClick}>WINDOW FILM</Link></li>
              </ul>
            </li>

            {/* WARRANTY dropdown (new) */}
            <li className={`nav-item dropdown ${warrantyOpen ? 'show' : ''}`}>
              <Link className="nav-link dropdown-toggle tb"
                    to="#"
                    role="button"
                    style={isWarrantyPage ? { color: '#ffc107' } : {}}
                    aria-expanded={warrantyOpen}
                    onClick={e => { e.preventDefault(); setWarrantyOpen(!warrantyOpen); }}>
                WARRANTY
              </Link>
              <ul className={`dropdown-menu bg-dark ${warrantyOpen ? 'show' : ''}`}>
                 {/* <li>
                  <Link className="dropdown-item text-warning"
                        to="/admin"
                        style={linkStyle.warrantyAdmin}
                        onClick={handleLinkClick}>
                    ADMIN
                  </Link>
                </li>*/}
                <li>
                  <Link className="dropdown-item text-warning"
                        to="/search"
                        style={linkStyle.warrantySearch}
                        onClick={handleLinkClick}>
                    CHECK WARRANTY
                  </Link>
                </li>
              </ul>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/installers" style={linkStyle.installers} onClick={handleLinkClick}>
                INSTALLERS
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link contact bg-dark text-warning" to="/#contact-us" onClick={handleLinkClick}>
                CONTACT US
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
